const { EventEmitter } = require('events');
const { JsonParser } = require('./parser');
const { JsonLexer } = require('./lexer');
/**
 * Removes ONE level of JSON-style escaping from a string literal.
 * • Works even if the fragment is incomplete or not valid JSON.
 * • Never uses eval / Function / JSON.parse.
 */



class JsonReconstructor extends EventEmitter {
  constructor() {
    super();
    this.reset();
  }

  reset() {
    this.lexer = new JsonLexer();
    this.parser = new JsonParser();
    this.parser.on('update', () => {
      //debugger
      // On any update, emit the complete current value
      this.emit('update', this.parser.rootValue);
    });
  }


  getValue = () => this.parser.rootValue

  process(rawChunk) {
    const decodedChunk = rawChunk
    for (const token of this.lexer.tokenize(decodedChunk)) {
      this.parser.processToken(token);
    }
  }

  getValue() {
    return this.parser.rootValue;
  }
}

module.exports = { JsonReconstructor };
